import React from 'react';
import { GreenTickCircleOutlineIcon } from '@/assets/icons/icons';
import { GxpReviewer } from './types';
import { Flex } from 'antd';
import { Link } from 'react-router-dom';
import { formatRelativeOrAbsoluteDate } from '../utils/formatRelativeOrAbsoluteDate';
import { getFormattedUserTimeZone } from '@/common/utils/utils';
import { useToken } from '@/common/helper';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
const STATUS_LABEL_CLASS: Record<string, string> = {
  auto: 'gxp-reviewer__status--auto',
  published: 'gxp-reviewer__status--published',
  pending: 'gxp-reviewer__status--pending',
  rejected: 'gxp-reviewer__status--rejected',
};

interface ReviewersCardProps {
  reviewers?: GxpReviewer;
  isAutoPublish?: boolean;
}

const ReviewersCard: React.FC<ReviewersCardProps> = ({
  reviewers,
  isAutoPublish,
}) => {
  const { decodedUserToken } = useToken();

  const isTimeZone = decodedUserToken()?.time_zone_enable;
  const dateFormat = decodedUserToken()?.date_format;

  let userTz: string | undefined;
  if (isTimeZone) {
    const tzString = getFormattedUserTimeZone();
    const match = tzString.match(/ ([A-Za-z_/]+)$/);
    userTz = match ? match[1] : dayjs.tz.guess();
  } else {
    userTz = dayjs.tz.guess();
  }
  const reviewerStatus = (
    reviewers?.status_label ??
    reviewers?.status ??
    ''
  ).toLowerCase();
  const isPublished = reviewerStatus === 'published';
  const isRejected = reviewerStatus === 'rejected';
  const hasReviewerDisposition = isPublished || isRejected;
  const reviewerStatusLabel = hasReviewerDisposition
    ? reviewerStatus.charAt(0).toUpperCase() + reviewerStatus.slice(1)
    : 'Pending';

  return (
    <div className='gxp-card gxp-sidebar-card'>
      <div className='gxp-card__title-row'>
        <div className='gxp-card__title'>Reviewers</div>
        {isAutoPublish && (
          <span className='gxp-status-tag gxp-status-tag--pass'>
            <GreenTickCircleOutlineIcon width={12} height={12} />
            Auto
          </span>
        )}
      </div>

      <div className='gxp-reviewers-list'>
        <div className='gxp-reviewer-row'>
          {!isAutoPublish && (
            <div className='gxp-reviewer-row__head'>
              <Flex vertical gap={2}>
                <span className='gxp-reviewer-row__name'>
                  {hasReviewerDisposition
                    ? (reviewers?.published_by_name ?? '--')
                    : 'Support'}
                </span>
                {hasReviewerDisposition ? (
                  <>
                    {formatRelativeOrAbsoluteDate(
                      reviewers?.published_at,
                      userTz,
                      dateFormat
                    )}
                  </>
                ) : (
                  'Pending review'
                )}
              </Flex>

              <span
                className={`gxp-reviewer__status ${STATUS_LABEL_CLASS[hasReviewerDisposition ? reviewerStatus : 'pending']}`}
              >
                {reviewerStatusLabel}
              </span>
            </div>
          )}

          {reviewers?.reviewer_note && hasReviewerDisposition ? (
            <div className='gxp-reviewer-row__comment'>
              {reviewers?.reviewer_note}
            </div>
          ) : null}

          {/* {reviewers?.published_at && (
  <div className='gxp-reviewer-row__timestamp'>
  {reviewers?.published_at}
  </div>
  )} */}
          {/* {reviewer.linkLabel && (
              <span className='gxp-reviewer-row__link'>
              {reviewer.linkLabel}
              </span>
              )} */}
        </div>

        {isAutoPublish && (
          <>
            <div className='gxp-reviewer-auto-row__helper'>
              This report was auto approved base on the{' '}
              <Link to='/settings/gxp-reports' className='review-flow-link'>
                {' '}
                review flow
              </Link>{' '}
              applied.
            </div>

            <Link
              to='/settings/gxp-reports'
              className='gxp-reviewer-auto-row__link'
            >
              Edit review flow
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default ReviewersCard;
